module.exports = __webpack_public_path__ + "media/images/welcomehdr-6c253f30d6e05d7743b338e9063f3a5d.png";